// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.broadcasterModeratorDisplayGlobal {
    padding-top: 1em;
    display: flex;
    flex-wrap: wrap;
    gap: 1em;
    animation: fadeInGlobal 0.4s;
}

.broadcasterDisplayModeratorLine {
    background-color: var(--DarkBlue);
    height: 4px;
    border: none;
}

.broadcasterCardDisplayContainer {
    position: relative;
    background-color: var(--DarkBlue);
    max-width: 20em;

    border-radius: 5px;
}

.broadcasterCardDisplayImage {
    max-height: 3em;
    width: 3em;
    height: 3em;
    border-radius: 50%;
    margin-top: auto;
    margin-bottom: auto;
}

.broadcasterCardDisplayImageNameContainer {
    display: flex;
    flex-wrap: wrap;
    gap: 1em;
    padding-left: 1em;
    padding-top: 0.5em;
    word-break: break-all;
}

.broadcasterCardDisplayName {
    margin-top: auto;
    max-width: 14em;
    margin-bottom: auto;
    font-size: 12px;
}

.broadcasterCardDisplayContainerApproveDeny {
    font-size: 12px;
    color: var(--Gray);
}

.broadcasterCardDisplayHr {
    background-color: var(--Gray);
    height: 1px;
    border: none;
}

.broadcasterCardDisplayPremissionsContainer {
    padding-left: 1em;
    padding-right: 1em;
    padding-bottom: 1em;
    transform: scale(0.7);
}

@media only screen and (max-width: 553px) {
    .broadcasterModeratorDisplayGlobal {
        justify-content: center;
    }
}

@media only screen and (max-width: 320px) {
    .broadcasterCardDisplayImageNameContainer {
        justify-content: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Moderation/ModeratorList/ModerationListDisplay/BroadcasterCardDisplay/broadcasterCardDisplay.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,QAAQ;IACR,4BAA4B;AAChC;;AAEA;IACI,iCAAiC;IACjC,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;;IAEf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":[".broadcasterModeratorDisplayGlobal {\n    padding-top: 1em;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1em;\n    animation: fadeInGlobal 0.4s;\n}\n\n.broadcasterDisplayModeratorLine {\n    background-color: var(--DarkBlue);\n    height: 4px;\n    border: none;\n}\n\n.broadcasterCardDisplayContainer {\n    position: relative;\n    background-color: var(--DarkBlue);\n    max-width: 20em;\n\n    border-radius: 5px;\n}\n\n.broadcasterCardDisplayImage {\n    max-height: 3em;\n    width: 3em;\n    height: 3em;\n    border-radius: 50%;\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.broadcasterCardDisplayImageNameContainer {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1em;\n    padding-left: 1em;\n    padding-top: 0.5em;\n    word-break: break-all;\n}\n\n.broadcasterCardDisplayName {\n    margin-top: auto;\n    max-width: 14em;\n    margin-bottom: auto;\n    font-size: 12px;\n}\n\n.broadcasterCardDisplayContainerApproveDeny {\n    font-size: 12px;\n    color: var(--Gray);\n}\n\n.broadcasterCardDisplayHr {\n    background-color: var(--Gray);\n    height: 1px;\n    border: none;\n}\n\n.broadcasterCardDisplayPremissionsContainer {\n    padding-left: 1em;\n    padding-right: 1em;\n    padding-bottom: 1em;\n    transform: scale(0.7);\n}\n\n@media only screen and (max-width: 553px) {\n    .broadcasterModeratorDisplayGlobal {\n        justify-content: center;\n    }\n}\n\n@media only screen and (max-width: 320px) {\n    .broadcasterCardDisplayImageNameContainer {\n        justify-content: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
